export default function(state = [], action){
    switch(action.type){
        case "SET_INCOMING_CALLS":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/incomingCalls.js